



























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { CvValue, FieldMetadataAccount } from '@/models'
import { loadAccountMetadata, FMAT_SELECT, FMAT_BOOL } from '@/utils/account-metadata'

/**
 * Read-only, collapsible display of the account's company-scoped metadata values, using the same
 * label/value format as the fixed fields in the account header.
 */
@Component
export default class AccountMetadataDetail extends Vue {
  @Prop({ default: '' }) companyId!: string
  @Prop({ default: () => ({}) }) value!: Record<string, any>

  private fields: FieldMetadataAccount[] = []
  private selectOptions: Record<string, CvValue[]> = {}
  private loading = false
  private loadError = false
  private expanded = false

  get metaModel(): Record<string, any> {
    return this.value || {}
  }

  @Watch('companyId')
  async onCompanyChange() {
    await this.loadFields()
  }

  async mounted() {
    if (this.companyId) {
      await this.loadFields()
    }
  }

  private async loadFields() {
    if (!this.companyId) {
      this.fields = []
      this.selectOptions = {}
      this.loadError = false
      return
    }
    try {
      this.loading = true
      this.loadError = false
      const { fields, selectOptions } = await loadAccountMetadata(this.companyId)
      this.fields = fields
      this.selectOptions = selectOptions
    } catch (error) {
      console.error('Error loading account metadata:', error)
      this.fields = []
      this.selectOptions = {}
      this.loadError = true
    } finally {
      this.loading = false
    }
  }

  private optionsFor(field: FieldMetadataAccount): CvValue[] {
    return (field.optionsId && this.selectOptions[field.optionsId]) || []
  }

  displayValue(field: FieldMetadataAccount): string {
    const raw = this.metaModel[field.fieldCode]
    if (field.typeId === FMAT_BOOL) {
      return raw ? this.$t('account_metadata_form.yes').toString() : this.$t('account_metadata_form.no').toString()
    }
    if (raw === undefined || raw === null || raw === '') {
      return '--'
    }
    if (field.typeId === FMAT_SELECT) {
      return this.optionsFor(field).find(option => option.codeId === raw)?.name || String(raw)
    }
    return String(raw)
  }
}
